import LabelImportantIcon from "@mui/icons-material/LabelImportantRounded";
import MoreVertIcon from "@mui/icons-material/MoreVertRounded";
import SaveAltOutlinedIcon from "@mui/icons-material/SaveAltOutlined";
import { IconButton, ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isFileDownloadAllowed } from "@entrilia/shared/utilities/fileHelper";
import useInboxStateContext from "../../../contexts/useInboxStateContext";
import { currentMessageSelector } from "../../../store/state/messages/selectors";
import { markAsImportant } from "../../../store/state/messages/thunks";
import type { Message } from "../../../store/state/messages/types";
import { impersonationSelector } from "../../../store/state/user/selectors";
import type { AppDispatch } from "../../../store/store";

interface Props {
  downloadAllAttachments: (message: Message) => void;
}

export const MessageMenu = (props: Props) => {
  const { downloadAllAttachments } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isImpersonation = useSelector(impersonationSelector);
  const dispatch: AppDispatch = useDispatch();
  const message = useSelector(currentMessageSelector);
  const { ui } = useInboxStateContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const changeImportance = useCallback(() => {
    if (message) {
      dispatch(markAsImportant([message.id], !message.isImportant));
    }
  }, [message, dispatch]);

  if (!message || ui.messageDetailLoading) {
    return <></>;
  }

  const hasDownloadableAttachment = message.attachments?.some((a) => isFileDownloadAllowed(a.accessOptions)) === true;

  return (
    <>
      {message.hasAttachments === true && hasDownloadableAttachment && (
        <IconButton onClick={() => downloadAllAttachments(message)}>
          <SaveAltOutlinedIcon />
        </IconButton>
      )}
      <IconButton className="menu" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            handleClose();
            changeImportance();
          }}
          disabled={isImpersonation}
        >
          <ListItemIcon>
            <LabelImportantIcon sx={(t) => ({ color: message?.isImportant ? t.palette.warning.light : "inherit" })} />
          </ListItemIcon>
          <Typography variant="inherit">
            {message?.isImportant ? "Mark as not Important" : "Mark as Important"}{" "}
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
};
export default MessageMenu;
